import { isPlatformServer } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { REQUEST, RESPONSE } from 'src/express.tokens';
import { routes } from 'utils/routes';
import { METADATA_SERVICE } from '../metadata/metadata.service';
import { SlugUserGQL } from './slug.query.generated';

export const userSlugGuard: CanActivateFn = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const query = inject(SlugUserGQL);
  const router = inject(Router);
  const metadataService = inject(METADATA_SERVICE);
  const platformId = inject(PLATFORM_ID);
  const request = isPlatformServer(platformId) ? inject(REQUEST) : null;
  const response = isPlatformServer(platformId) ? inject(RESPONSE) : null;
  const slug = route.params['slug'];
  if (slug) {
    return query.fetch({ slug }).pipe(
      map(r => {
        if (slug !== r.data?.userBySlug?.slug && isPlatformServer(platformId)) {
          if (response) {
            response.redirect(
              301,
              routes[request.i18n?.language as 'it']['routes.profile'] + '/' + r.data?.userBySlug?.slug,
            );
          }
        }
        if (r.data?.userBySlug?.id) {
          metadataService.setTitle(r.data?.userBySlug?.metaTag?.title);
          metadataService.setDescription(r.data?.userBySlug?.metaTag?.description);
          return true;
        } else {
          return router.parseUrl('/not-found');
        }
      }),
      catchError(() => of(router.parseUrl('/not-found'))),
    );
  } else {
    return router.parseUrl('/not-found');
  }
};
